<template>
    <div class="title_block">



            <div v-if="title&&description">
                <div class="title_count">
                    <h1 class="mb-0 text-left font-active">{{ title }}</h1>
                    <h6 v-if="total" class="total_count font-active mb-0">({{ total }})</h6>
                </div>
                <p :class="{'overFlow': maxHeight}" class="mb-0 mt-2">{{ description }}</p>
                <div v-if="maxHeight && description.length > 170" @click="maxHeight = false" class="read_btn">... Read More</div>
                <div v-else @click="maxHeight = true" class="read_btn">... Read Less</div>
            </div>


            <div v-else> 
                <div class="placeholder-glow skeleton_title mb-2">
                    <div class="placeholder skeleton"></div>
                </div>
                <div class="placeholder-glow skeleton_desc">
                    <div class="placeholder skeleton"></div>
                </div>

            </div>

            <!-- <div v-else> -->
                <!-- <b-skeleton class=" mb-0" width="30%"  height="40px"></b-skeleton>
                <div class="mb-0 mt-3" >
                    <b-skeleton class="mb-0" width="70%" height="20px"></b-skeleton>
                    <b-skeleton class="mb-2 mt-1" width="90%" height="20px"></b-skeleton>
                </div> -->
            <!-- </div> -->

        
       
    </div>
</template>

<script setup>

    const { title, description, total } = defineProps(['title', 'description', 'total'])
    const skeleton = ref(false)
    const maxHeight = ref(true)

</script>

<style scoped>

h1 {
    font-size: 20px;
    text-align: left;
}

p {
   font-size: 16px;
    text-align: left;
    line-height: 1.5;
    color: #6a6161;
}
.title_block {
    margin: 2% 0;
}
.read_btn {
    display: none;
}
.title_count {
    display: flex;
    align-items: baseline;
}

.title_count h6 {
    margin-left: 5px;
    color: #606060;
    font-size: 16px;
}
@media(max-width:992px){
    .read_btn {
        display: block;
        color: var(--green);
        font-size: 16px;
        line-height: 1.5;
    }
    .overFlow {
        height: 53px;
        overflow: hidden;
    }
}
@media(max-width:767px){
   .title_block {
        margin: 6% 0;
    }
    h1 {
        font-size: 18px;
    }
    p {
        font-size: 14px;
        margin-top: 10px !important;
    }
    .read_btn{
        font-size: 14px;
    }
    .overFlow {
        height: 45px;
        overflow: hidden;
    }
}

.skeleton_title{
    height: 40px;
    width: 28%;
}
.skeleton_desc{
    height: 80px;
    width: 100%;
}

.skeleton{
    height: 100%;
    width: 100%;
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.3);
    mask-image: radial-gradient(white, black);
    cursor: wait;
    overflow: hidden;
}



</style>
